import Column from './containers/Column'

const Screen = Column

export default Screen
